import { Injectable } from '@angular/core';
import { Business } from '@models/businesses';
import {
	Matter,
	PersonMatterClient,
	BusinessMatterClient,
} from '@models/matter';
import { AllAdjustmentsCalculated } from '@state/matter/adjustments/adjustments.selectors';
import { cloneDeep } from 'lodash';
import { BaseFormMapper } from '../../base-form-mapper';
import { NameFormattingSettings } from '@models/businessSettings/settings';

@Injectable({
	providedIn: 'root',
})
export class CIBC_DOCUMENTS_COMMERCIAL_COLLATERAL_MORTGAGE_FINAL_REPORT_Mapper extends BaseFormMapper<CIBC_DOCUMENTS_COMMERCIAL_COLLATERAL_MORTGAGE_FINAL_REPORT> {
	CloserToFormMappings = Mappings;

	mergeFormData(
		formData: CIBC_DOCUMENTS_COMMERCIAL_COLLATERAL_MORTGAGE_FINAL_REPORT,
		matter: Matter,
		nameFormattingSettings: NameFormattingSettings,
		sellers: (PersonMatterClient | BusinessMatterClient)[],
		buyers: (PersonMatterClient | BusinessMatterClient)[],
		adjustments: AllAdjustmentsCalculated,
		business: Business,
	) {
		const _formData = formData
			? cloneDeep(formData)
			: ({} as CIBC_DOCUMENTS_COMMERCIAL_COLLATERAL_MORTGAGE_FINAL_REPORT);

		return _formData;
	}

	MapValues(): Partial<CIBC_DOCUMENTS_COMMERCIAL_COLLATERAL_MORTGAGE_FINAL_REPORT> {
		return {};
	}
}

const Mappings: CIBC_DOCUMENTS_COMMERCIAL_COLLATERAL_MORTGAGE_FINAL_REPORT = {
	// "0":"ButtonSubmit0",
	registrationDate: 'Text1111111111111111',
	guarantor: 'Text110',
	mortgagor: 'Text103',
	// "4":"Text1",
	signature: 'Text124',
	solictorFirmName: 'Text123',
	dateYear: 'Text122',
	dateMonth: 'Text121',
	dateDay: 'Text120',
	datedAt: 'Text119',
	exceptions: 'Text125',
	agent: 'Text115',
	policyNumber: 'Text114',
	fireInsuranceName: 'Text113',
	taxesPaidTo: 'Text112',
	parcelIdentification: 'Text108',
	registrationNumber: 'Text106',
	mortgageAmount: 'Text111',
	registryOffice: 'Text109',
	mortgageDate: 'Text107',
	electronicRegistration: 'CC007',
	legalDescription: 'Text105',
	propertyAddress: 'Text104',
	cibcReferenceNumber: 'Text102',
	to: 'Text101',
};

export interface CIBC_DOCUMENTS_COMMERCIAL_COLLATERAL_MORTGAGE_FINAL_REPORT {
	cibcReferenceNumber: string;
	to: string;
	mortgagor: string;
	guarantor: string;
	propertyAddress: string;
	legalDescription: string;

	electronicRegistration: string;
	registrationNumber: string;

	mortgageDate: string;
	registrationDate: string;

	registryOffice: string;
	parcelIdentification: string;

	mortgageAmount: string;
	taxesPaidTo: string;

	fireInsuranceName: string;
	policyNumber: string;
	agent: string;

	// enclosures:string,

	datedAt: string;
	dateDay: string;
	dateMonth: string;
	dateYear: string;

	solictorFirmName: string;
	signature: string;

	exceptions: string;
}
